module.exports = __webpack_public_path__ + "img/iq.77828901.svg";